import { getWorker, optimizeImage } from './ocrService';

export const processPDF = async (file, onProgress) => {
  if (!window.pdfjsLib) {
    onProgress(10, 'راه‌اندازی موتور پردازش اسناد...');
    await new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
      script.onload = () => {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
        resolve();
      };
      script.onerror = () => reject(new Error('خطا در بارگذاری موتور PDF'));
      document.head.appendChild(script);
    });
  }

  onProgress(15, 'استخراج لایه‌های سند...');
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await window.pdfjsLib.getDocument(arrayBuffer).promise;
  let fullText = '';

  for (let i = 1; i <= pdf.numPages; i++) {
    const baseProgress = 15 + Math.floor((i / pdf.numPages) * 80);
    onProgress(baseProgress, `بررسی صفحه ${i} از ${pdf.numPages}...`);
    
    const page = await pdf.getPage(i);
    const textContent = await page.getTextContent();
    const pageText = textContent.items.map(item => item.str).join(' ').trim();

    // سیستم هیبریدی: اگر متن صفحه کمتر از 30 کاراکتر بود، یعنی اسکن شده است
    if (pageText.length > 30) {
      fullText += `--- صفحه ${i} (متنی) ---\n${pageText}\n\n`;
    } else {
      onProgress(baseProgress, `صفحه ${i} اسکن شده است. اجرای بینایی ماشین (OCR)...`);
      
      // تبدیل صفحه PDF به Canvas
      const viewport = page.getViewport({ scale: 1.5 }); // مقیاس 1.5 تعادل بین دقت و مصرف رم
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      
      await page.render({ canvasContext: ctx, viewport }).promise;
      const imgData = canvas.toDataURL('image/jpeg', 0.8);
      
      // فراخوانی موتور OCR روی Canvas استخراج شده
      const worker = await getWorker(onProgress);
      const optimizedDataUrl = await optimizeImage(imgData);
      
      const { data: { text } } = await worker.recognize(optimizedDataUrl);
      fullText += `--- صفحه ${i} (توسط OCR) ---\n${text}\n\n`;
    }
  }
  
  onProgress(100, `پردازش ${pdf.numPages} صفحه با موفقیت پایان یافت.`);
  return fullText || 'سند فاقد اطلاعات قابل استخراج بود.';
};
